<template>
  <div style="display: inline-block;">
    <b-btn
      v-b-tooltip.hover
      title="Visualizar"
      variant="none"
      class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
      :disabled="!gridProps.row.hasFile"
      @click="abrirArquivo(gridProps.row)"
    >
      <font-awesome-icon
        :icon="faExternalLinkAlt"
        class="text-primary"
      />
    </b-btn>

    <b-btn
      v-b-tooltip.hover
      title="Histórico"
      variant="none"
      class="btn-none icone-acao m-0 p-0"
      @click="openModalHistorico()"
    >
      <font-awesome-icon
        icon="fa-sharp fa-solid fa-list"
        class="text-primary"
      />
    </b-btn>

    <b-btn
      v-b-tooltip.hover
      title="Observação"
      variant="none"
      class="btn-none rounded-pill m-0 icone-acao p-0"
      @click="openModalObservacao()"
    >
      <font-awesome-icon
        icon="fa-regular fa-message"
        :class="{
          'text-success': todasObservacoesLidas,
          'text-warning': !todasObservacoesLidas && temObservacaoNova,
          'text-primary': !todasObservacoesLidas && !temObservacaoNova
        }"
      />
    </b-btn>

    <modal-observacao
      ref="modalObservacao"
      v-model="gridProps.row"
      tipo="PgMei"
      :api="api"
      :notificar="{ sucesso: notficarSucesso, erro: notificarErro }"
      @hidden="fecharObservacao($event)"
    />

    <visualizar-arquivo
      v-if="mostrarArquivo && arquivo.url"
      :url="arquivo.url"
      @hidden="fecharArquivo()"
    />

    <modal-historico
      :ref="`modalHistorico${gridProps.row.id}`"
      rotina="PG Mei"
      des-de="2026"
      :empresa="gridProps.row"
      tipo="PgMei"
      :api="api"
      :coluna-historico="colunaHistorico"
      :filtro-by-historico="['ConsultadoEm']"
      :acoes-lote="{}"
      :acaos-individuais="({
        download: false,
        enviarEmail: false,
        enviarWhatsApp: false,
        observacao: true,
      })"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import api from '../../../services/api'
import colunasHistorico from '../historico'

export default {
  components: {
    FontAwesomeIcon,
    VisualizarArquivo: () => import('@pilar/components/visualizar-arquivo/VisualizarArquivo.vue'),
    ModalObservacao: () => import('@/app/shared/components/modal-observacao/ModalObservacao.vue'),
    ModalHistorico: () => import('@/app/shared/components/historico/ModalHistorico.vue'),
  },
  props: {
    gridProps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      api,
      faExternalLinkAlt,
      mostrarArquivo: false,
      arquivo: {},
    }
  },
  computed: {
    temObservacaoNova() {
      return this.gridProps?.row?.temObservacao ?? false
    },
    todasObservacoesLidas() {
      return this.gridProps?.row?.todasObservacoesLidas ?? false
    },
    colunaHistorico() {
      return colunasHistorico
    },
  },
  methods: {
    abrirArquivo(linha) {
      api.getURL(linha.id)
        .then(payload => {
          this.arquivo.url = payload.data
          this.mostrarArquivo = true
        })
        .catch(err => {
          this.fecharArquivo()
          this.notificarErro('Não foi possível abrir a visualização do arquivo.')
          throw err
        })
    },

    fecharArquivo() {
      this.mostrarArquivo = false
      this.arquivo = {}
    },

    openModalHistorico() {
      this.$refs[`modalHistorico${this.gridProps.row.id}`].abrirModal()
    },

    openModalObservacao() {
      this.$refs.modalObservacao.show()
    },

    fecharObservacao(observacaoNova) {
      this.gridProps.row.temObservacao = observacaoNova.hasObservacaoNova
      this.gridProps.row.todasObservacoesLidas = observacaoNova.observacaoLida
    },

    notficarSucesso(msg) {
      this.$sucesso(msg)
    },

    notificarErro(msg) {
      this.$erro(msg)
    },
  },
}
</script>
